/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements } from '@/blocks/block_compatibility_checks';
import { AreaService } from '@/services/area.service';

Blockly.Blocks['input_earthquake_data'] = {
    init: function () {
        let areas = AreaService.getAreas();
        this.appendDummyInput()
            .appendField('Earthquake Data: ')
            .appendField(new Blockly.FieldDropdown([
                ['China_129A_04939_131313_20200116_20200128_geo_diff_pha', 'leeds_china_phase_diff'],
                ['China_129A_04939_131313_20200116_20200128_geo_unw', 'leeds_china_unwrapped'],
                ['Iceland_155D_02579_100800_20201020_20201026_geo_diff_pha', 'leeds_iceland_phase_diff'],
                ['Iceland_155D_02579_100800_20201020_20201026_geo_unw', 'leeds_iceland_unwrapped'],
                ['Nevada_144D_05102_121313_20200329_20200516_geo_diff_pha', 'leeds_nevada_phase_diff'],
                ['Nevada_144D_05102_121313_20200329_20200516_geo_unw', 'leeds_nevada_unwrapped'],
                ['Turkey_116A_05167_121313_20200115_20200127_geo_diff_pha', 'leeds_turkey_phase_diff'],
                ['Turkey_116A_05167_121313_20200115_20200127_geo_unw', 'leeds_turkey_unwrapped'],
                ['Xizang_121D_05668_131313_20200702_20200726_geo_diff_pha', 'leeds_xizang_phase_diff'],
                ['Xizang_121D_05668_131313_20200702_20200726_geo_unw', 'leeds_xizang_unwrapped']
            ]), "param")
        this.appendDummyInput('inp')
            .appendField("Area: ", 'area_text')
            .appendField(new Blockly.FieldDropdown(areas), "area")
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('earthquake'))

        this.setInputsInline(false);
        this.setStyle('terrain');
        this.setTooltip("Earthquare Interferomety data selection block. ");
        this.setHelpUrl("");
    }
};
